var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fontisto:arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5469 15.3329L8.97793 15.3332L13.036 11.3282L13.9032 10.4724L12.6848 10.4724L3.83366 10.4724L3.83366 9.52773L12.6859 9.52773L13.9045 9.52773L13.0371 8.67181L8.9779 4.66671L10.5475 4.66671L15.9549 9.99949L10.5469 15.3329Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.388c0ba5337ba7802be0f41170f39771.svg";
export { ForwardRef as ReactComponent };